import { ready, onShopifySectionLoad } from './utils/readyinit';
import { initSwiper, initSwiperMobile } from './components/swiper';
import initAccordion from './components/accordion';
import initLazyloadVideo from './utils/lazyloadVideo';
import initNavigation from './sections/header/navigation';
import initTransparentHeader from './sections/header/header';
import initCustomDropdowns from './components/custom-dropdowns';
import initAtcForm from './components/atcForm';
import initFeaturedMedia from './sections/featured-media';
import initSearch from './sections/header/search';
import initTabbedTiles from './sections/tabbed-tiles';
import initSubscriptionTiles from './sections/subscription-options';
import initNewsletter from './components/newsletter';
import initContactFormSuccess from './components/contact-form-success';

ready(() => {
  initSwiper();
  initSwiperMobile();
  initCustomDropdowns();
  initTransparentHeader();
  initSearch();
  initNavigation();
  initAccordion();
  initLazyloadVideo();
  initAtcForm();
  initFeaturedMedia();
  initTabbedTiles();
  initSubscriptionTiles();
  initNewsletter();
  initContactFormSuccess();
});

onShopifySectionLoad(() => {
  initSwiper();
  initSwiperMobile();
  initCustomDropdowns();
  initTransparentHeader();
  initSearch();
  initNavigation();
  initLazyloadVideo();
  initAtcForm();
  initFeaturedMedia();
  initTabbedTiles();
  initSubscriptionTiles();
  initNewsletter();
  initContactFormSuccess();
});
